module.exports = __webpack_public_path__ + "img/teams.38a45759.svg";